import * as React from 'react'
import {Component, ReactElement} from 'react'
import {RECEIVING_AGENCY_CD} from '../../../CodeMaster'
import CondominiumsRepository from '../../../components/condominiums/CondominiumsRepository'
import {
    createResidentWithErrorHandlingPage,
    ResidentWithErrorHandlingPagePropsSet,
} from '../../../components/shared/hoc/createResidentWithErrorHandlingPage'
import {Location} from 'react-router-dom'


interface Props {
    condominiumCd: string
    condominiumsRepo: CondominiumsRepository
    location: Location
}

class NatResidentAccountTransferRedirectPage extends Component<Props & ResidentWithErrorHandlingPagePropsSet> {
    constructor(props: Readonly<Props & ResidentWithErrorHandlingPagePropsSet>) {
        super(props)
    }

    async componentDidMount(): Promise<void> {
        const {eventEmitter, asyncCallFunction, condominiumCd, condominiumsRepo, navigate} = this.props

        await eventEmitter.showLoading()
        try {
            const assocAccountingDeptResponse = await asyncCallFunction(
                condominiumsRepo.getAssocAccountingDept.bind(condominiumsRepo, condominiumCd),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(eventEmitter)
                },
            )
            const receivingAgencyCd = assocAccountingDeptResponse?.receivingAgencyCd
            if (receivingAgencyCd !== RECEIVING_AGENCY_CD.RESONA_KS
                && receivingAgencyCd !== RECEIVING_AGENCY_CD.SMBC_CARD) {
                return
            }
            navigate(
                `/resident/condominiums/${condominiumCd}/applications/account-transfer/${receivingAgencyCd.value}`,
                {replace: true},
            )
        } finally {
            await eventEmitter.closeLoading()
        }
    }

    render(): ReactElement {
        return <></>
    }
}

export default createResidentWithErrorHandlingPage(NatResidentAccountTransferRedirectPage)
